<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Experiências</p>

        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.experiencias"></p>
      </v-flex>

      <v-flex xs12 style="margin-top: 20px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Alfredo Wagner – SC: Natureza, Cultura e Aventura</p>

        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.experiencias2"></p>
      </v-flex>

      <p></p>
      <v-flex xs12 v-if="$vuetify.breakpoint.mdAndUp">
        <v-responsive :aspect-ratio="16 / 9" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="experiencias" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>
      <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
        <v-responsive :aspect-ratio="9 / 16" style="width: 100vw">
          <video autoplay muted loop playsinline style="width: 100%; height: 100%; object-fit: cover">
            <source v-bind:src="experienciasRetrato" type="video/mp4" />
          </video>
        </v-responsive>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '130px' : '60px'};`"></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    blog: { default: false }
  },
  data() {
    return {};
  },
  computed: {
    experiencias() {
      return process.env.VUE_APP_URL_API + `arquivos/Experiencias.mp4`;
    },
    experienciasRetrato() {
      return process.env.VUE_APP_URL_API + `arquivos/ExperienciasRetrato.mp4`;
    }
  }
};
</script>
